import React from "react";
import clsx from "clsx";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import { makeStyles, Collapse } from "@material-ui/core";
import RequestedTable from "./RequestedTable";

const Requested = ({
  rolesAndFeatures,
  updatedTransfers,
  showAdHocRequestModal,
  transfersList,
  setIsRequestedItemDragging,
  setDraggingItemName,
  selectedLocationId,
}: any) => {
  const classes = useStyles();
  const [isCollapsed, setIsCollapsed] = React.useState(false);
  const [wardMode, setWardMode] = React.useState(0);
 
  const headerSubTitle = `${transfersList.length} Transfer${transfersList.length > 1 ? "s" : ""}`;

  return (
    <div className={classes.root}>
      <div className={classes.heading}>
        <div
          className={classes.headWrapping}
          onClick={() => {
            setIsCollapsed(!isCollapsed);
          }}
        >
          {!isCollapsed ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
          <span className={classes.headerTitle}>Requested</span>
          {isCollapsed && <span className={classes.headerSubTitle}>{headerSubTitle}</span>}
          <p className={classes.headerTitleAdditional}>To schedule a transfer, drag it to a planner, or to ad-hoc requests</p>
        </div>

        {rolesAndFeatures.wardSwitch && !isCollapsed && (
          <div className={classes.transferSwitchContainer}>
            <span
              onClick={() => {
                setWardMode(0);
              }}
              className={clsx(classes.transerSwitch, {
                [classes.transerSwitchActive]: wardMode === 0,
              })}
            >
              All Wards
            </span>
            <span
              onClick={() => {
                setWardMode(1);
              }}
              className={clsx(classes.transerSwitch, {
                [classes.transerSwitchActive]: wardMode === 1,
              })}
            >
              My Wards
            </span>
          </div>
        )}
      </div>

      <Collapse in={!isCollapsed} timeout="auto" unmountOnExit>
        <RequestedTable
          transfers={transfersList || []}
          updatedTransfers={updatedTransfers}
          wardMode={wardMode}
          showAdHocRequestModal={showAdHocRequestModal}
          setIsRequestedItemDragging={setIsRequestedItemDragging}
          setDraggingItemName={setDraggingItemName}
          roles={rolesAndFeatures}
          selectedLocationId={selectedLocationId}
          setWardMode = {setWardMode}
        />
      </Collapse>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#00152E",
    marginTop: 15,
  },
  heading: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 28,
  },
  headWrapping: {
    cursor: "pointer",
    paddingLeft: 14,
    display: "flex",
    alignItems: "center",
  },
  headerTitle: {
    fontSize: 21,
    fontWeight: 400,
    marginLeft: 15,
  },
  headerSubTitle: {
    fontSize: 21,
    fontWeight: 500,
    opacity: 0.36,
    marginLeft: 15,
  },
  headerTitleAdditional: {
    fontSize: 16,
    fontWeight: 400,
    fontFamily: "Lato",
    margin: "0 0 0 36px",
    color: "rgba(255, 255, 255, 0.3)",
  },
  transferSwitchContainer: {
    display: "inline-flex",
    float: "right",
    marginRight: 25,
    border: "1px solid #02489D",
    borderRadius: 20,
    overflow: "hidden",
  },
  transerSwitch: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 150,
    height: 32,
    fontSize: 14,
    fontWeight: 500,
    cursor: "pointer",
  },
  transerSwitchActive: {
    backgroundColor: "#02489D",
  },
}));

export default Requested;
